<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

import versionSelectService from '@/services/embeds/plugin/version.select.service'
import { useIdeStore } from '@/stores/embeds/ide.store'

import { useEmbedConfigureStore } from '@/stores/embeds/embedConfigure.store'

import { cloneDeep } from 'lodash-es'

const ideStore = useIdeStore()
const embedConfigStore = useEmbedConfigureStore()

const { getOnEditMode } = storeToRefs(embedConfigStore)
const { getVersionListHideTitle, getVersionListTitleName, getVersionListDisplay } =
  storeToRefs(ideStore)

const versions = computed(() => {
  const versions = ideStore.selectedLanguageVersionsList || []
  return cloneDeep(versions)
    .map((version, index) => {
      return {
        index,
        version
      }
    })
    .reverse()
})

onMounted(async () => {
  await new Promise((resolve) => setTimeout(resolve, 100))
  if (getOnEditMode.value === false) {
    versionSelectService.initVersionList()
    versionSelectService.onSettingChange()
  }
})
onBeforeUnmount(async () => {
  if (getOnEditMode.value === false) {
    versionSelectService.destroyVersionList()
  }
  await new Promise((resolve) => setTimeout(resolve, 100))
})
</script>

<template>
  <div
    :class="[
      'flex h-full w-full gap-2 ',
      {
        'flex-col': !getVersionListDisplay
      },
      {
        'flex-row items-center': getVersionListDisplay
      }
    ]"
  >
    <label v-if="getVersionListHideTitle" class="min-w-fit font-semibold leading-6">
      {{ getVersionListTitleName }}</label
    >
    <select
      class="block h-12 w-full rounded-md border border-gray-400 px-2 outline-none"
      v-model="ideStore.selectedVersion"
      :disabled="versions.length <= 0"
    >
      <option v-for="version in versions" :key="version.index" :value="version.index">
        {{ version.version }}
      </option>
    </select>
  </div>
</template>
